/*
 * @Date: 2024-07-19 12:53:28
 * @LastEditors: p彭 9878922+p-pengrulin@user.noreply.gitee.com
 * @LastEditTime: 2024-10-10 10:29:05
 */
import request from "@/utils/request";

class Request {
  constructor(url) {
    this.url = url;
  }

  //这样写，方便于同url，不同方法（比如get/post）的情况
  Get(config) {
    return request({
      ...config,
      url: this.url,
      method: "get",
    });
  }

  Post(config) {
    return request({
      ...config,
      url: this.url,
      method: "post",
    });
  }

  Put(config) {
    return request({
      ...config,
      url: this.url,
      method: "Put",
    });
  }

  Delete(config) {
    return request({
      ...config,
      url: this.url,
      method: "Delete",
    });
  }
}

export default Request;
